document.addEventListener('DOMContentLoaded', () => {
  
  function scrollToField(field) {
    if (!field) return;
  
    const yOffset = -120; // adjust if you have a sticky header
    const y = field.getBoundingClientRect().top + window.pageYOffset + yOffset;
  
    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  }
  
  const formCollapse = function() {
    const forms = document.querySelectorAll('.survey-form');
    if (!forms.length) return;
    
    function zf_ValidateAndSubmit() {
    
      const form = document.querySelector('.survey-form');
      if (!form) return false;
    
      const questions = form.querySelectorAll('.question');
    
      for (const question of questions) {
        if (!validateQuestion(question)) {
          return false; // HARD STOP like Zoho expects
        }
      }
    
      return true; // allow submission
    }

    const zf_MandArray = ["Radio", "Radio1", "Radio2", "Date", "SingleLine", "Name_First", "Name_Last", "Email", "Email1", "Radio3", "DecisionBox"];
    const zf_FieldArray = ["Radio", "Radio1", "Radio2", "Date", "SingleLine", "Name_First", "Name_Last", "Email", "Email1", "PhoneNumber_countrycode", "Radio3", "SingleLine1", "DecisionBox"];

    function zf_ShowErrorMsg(name) {
      const errorEl = document.getElementById(name + "_error");
      if (!errorEl) return;
    
      errorEl.style.display = 'block';
    
      // Find the related input field
      const field = document.querySelector(`[name="${name}"]`);
    
      // If not found (like radio groups), scroll to the question container
      const target = field ? field.closest('.question') || field : errorEl.closest('.question') || errorEl;
    
      const yOffset = -120; // adjust for sticky header
      const y = target.getBoundingClientRect().top + window.pageYOffset + yOffset;
    
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }

    function zf_HideErrorMsg(name) {
      const el = document.getElementById(name + "_error");
      if (el) el.style.display = 'none';
    }

    const dateMonths = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    const dateMonthIndex = dateMonths.reduce((months, month, index) => {
      months[month] = index;
      return months;
    }, {});

    function formatDateForZoho(date) {
      return `${String(date.getDate()).padStart(2,'0')}-${dateMonths[date.getMonth()]}-${date.getFullYear()}`;
    }

    function isValidDate(year, monthIndex, day) {
      const date = new Date(year, monthIndex, day);
      return date.getFullYear() === year && date.getMonth() === monthIndex && date.getDate() === day;
    }

    function parseDobDate(dateStr) {
      const value = (dateStr || '').trim();

      const zohoMatch = value.match(
        /^(0[1-9]|[12][0-9]|3[01])-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d{4})$/i
      );

      if (zohoMatch) {
        const [ , day, mon, year ] = zohoMatch;
        const normalizedMonth = mon.charAt(0).toUpperCase() + mon.slice(1).toLowerCase();
        const monthIndex = dateMonthIndex[normalizedMonth];
        const numericYear = Number(year);
        const numericDay = Number(day);

        if (monthIndex === undefined || !isValidDate(numericYear, monthIndex, numericDay)) return null;

        return new Date(numericYear, monthIndex, numericDay);
      }

      const displayMatch = value.match(/^(\d{2})-(\d{2})-(\d{4})$/);

      if (displayMatch) {
        const [ , month, day, year ] = displayMatch;
        const numericYear = Number(year);
        const monthIndex = Number(month) - 1;
        const numericDay = Number(day);

        if (monthIndex < 0 || monthIndex > 11 || !isValidDate(numericYear, monthIndex, numericDay)) return null;

        return new Date(numericYear, monthIndex, numericDay);
      }

      const nativeMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);

      if (nativeMatch) {
        const [ , year, month, day ] = nativeMatch;
        const numericYear = Number(year);
        const monthIndex = Number(month) - 1;
        const numericDay = Number(day);

        if (monthIndex < 0 || monthIndex > 11 || !isValidDate(numericYear, monthIndex, numericDay)) return null;

        return new Date(numericYear, monthIndex, numericDay);
      }

      return null;
    }

    function normalizeDobDate(dateStr) {
      const date = parseDobDate(dateStr);
      return date ? formatDateForZoho(date) : null;
    }
    
    const jsDate = document.querySelector('.js-date');
    
    if(jsDate) {
      flatpickr(jsDate, {
        dateFormat: 'd-M-Y',
        altInput: true,
        altFormat: 'm-d-Y',
        allowInput: true,
        clickOpens: true,
        disableMobile: false,
      
        parseDate(dateStr) {
          return parseDobDate(dateStr);
        },
      
        onChange(_, dateStr, instance) {
          zf_HideErrorMsg('Date');
        }
      });
    }
    


    function zf_ValidateEmailID(field) {
      const email = (field.value || '').trim();
      if (!email) return true;
      const emailExp = /^[\w]([\w\-.+&'/]*)@([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,22}$/;
      return emailExp.test(email);
    }
    
    function zf_ValidatePhone(field) {
      const val = (field.value || '').trim();
    
      // Optional field → empty is valid
      if (!val) return true;
    
      // Remove common separators for length check
      const digitsOnly = val.replace(/[^\d]/g, '');
    
      // Must be between 10 and 15 digits (E.164 standard)
      if (digitsOnly.length < 10 || digitsOnly.length > 15) {
        return false;
      }
    
      // General international phone pattern
      const phoneRegex = /^\+?[\d\s().-]+$/;
    
      return phoneRegex.test(val);
    }

    function validCheck(field, questionElem) {
      const type = field.getAttribute('checktype');

      switch (type) {
        
        case 'c1': // radio or checkbox
        if (field.type === 'radio') {
          // Validate radio group
          const radios = questionElem.querySelectorAll(`input[name="${field.name}"]`);
          const checked = Array.from(radios).some(r => r.checked);
          if (!checked) return false;
        
          // Special case: Radio3 "Other" needs the extra text field.
          if (field.name === 'Radio3') {
            const otherRadio = questionElem.querySelector('#Radio3_3');
            const otherField = questionElem.querySelector('[name="SingleLine1"]');
            if (otherRadio && otherRadio.checked) {
              if (!otherField || otherField.value.trim() === '') {
                zf_ShowErrorMsg('SingleLine1');
                if (otherField) otherField.focus();
                return false;
              }
            }
          }
        }
        
        if (field.type === 'checkbox') {
          // Validate required checkbox
          if (!field.checked) return false;
        }
        
        return true;
          
        case 'c2': return true; // number validation placeholder
        case 'c3': return true; // currency validation placeholder
        
        
        case 'c4': 
        const val = field.value.trim();
        
        // If mandatory and empty, invalid
        if (zf_MandArray.includes(field.name) && val === '') {
          field.focus();
          zf_ShowErrorMsg(field.name);
          return false;
        }
        
        // Only validate if there is a value
        if (val !== '') {
          const normalizedDate = normalizeDobDate(val);
          if (!normalizedDate) {
            field.focus();
            zf_ShowErrorMsg(field.name);
            return false;
          }
        
          field.value = normalizedDate;
        }
        
        // Passed validation
        zf_HideErrorMsg(field.name);
        return true;

        case 'c5': // email
          if (!zf_ValidateEmailID(field)) return false;
          if (field.name === 'Email1' && questionElem) {
            const original = questionElem.querySelector('[name="Email"]');
            if (original && field.value.trim() !== original.value.trim()) return false;
          }
          return true;
          
        case 'c6': return true; // URL validation placeholder
        
        case 'c7': { // phone number
          if (!zf_ValidatePhone(field)) {
            field.focus();
            zf_ShowErrorMsg('PhoneNumber');
            return false;
          }
        
          zf_HideErrorMsg('PhoneNumber');
          return true;
        }
        
        case 'c8': return true; // signature validation placeholder
        case 'c9': return true; // month-year validation placeholder

        default: return true;
      }
    }

    function validateQuestion(questionElem) {
      let isValid = true;
    
      // ---- Name question special handling (RUN ONCE) ----
      if (questionElem.classList.contains('js-name-question')) {
        const first = questionElem.querySelector('[name="Name_First"]');
        const last  = questionElem.querySelector('[name="Name_Last"]');
    
        const firstVal = first.value.trim();
        const lastVal  = last.value.trim();
    
        // Reset
        first.classList.remove('zf-invalid');
        last.classList.remove('zf-invalid');
        zf_HideErrorMsg('Name');
    
        if (!firstVal || !lastVal) {
          zf_ShowErrorMsg('Name');
    
          if (!firstVal) first.classList.add('zf-invalid');
          if (!lastVal) last.classList.add('zf-invalid');
    
          (!firstVal ? first : last).focus();
          return false; // ✅ THIS NOW STOPS VALIDATION
        }
      }
    
      // ---- Validate remaining fields ----
      const fields = questionElem.querySelectorAll('input, select, textarea, object');
    
      for (const field of fields) {
        if (!field.name) continue;
    
        // mandatory check
        if (zf_MandArray.includes(field.name)) {
          if ((field.value || '').trim() === '' && field.type !== 'radio') {
            zf_ShowErrorMsg(field.name);
            return false;
          }
    
          if (field.type === 'radio') {
            const group = questionElem.querySelectorAll(`input[name="${field.name}"]`);
            const checked = Array.from(group).some(r => r.checked);
            if (!checked) {
              zf_ShowErrorMsg(field.name);
              return false;
            }
          }
        }
    
        // type-specific validation
        if (zf_FieldArray.includes(field.name)) {
          if (!validCheck(field, questionElem)) {
            if (field.name !== 'Radio3') {
              zf_ShowErrorMsg(field.name);
            }
            return false;
          } else {
            zf_HideErrorMsg(field.name);
            if (field.name === 'Radio3') {
              zf_HideErrorMsg('SingleLine1');
            }
          }
        }
      }
    
      return true;
    }

    forms.forEach(form => {
      const showAllMode = form.classList.contains('show-all-fields');
      const buttons = form.querySelectorAll('button[aria-expanded]');
      
      if (showAllMode) {
        // show/hide questions
        form.querySelectorAll('.question').forEach(q => {
          q.style.display = 'block';
          q.style.height = 'auto';
        });
      
        // Hide next buttons
        buttons.forEach(btn => {
          btn.parentElement.style.display = 'none';
        });
      }
    
      buttons.forEach(button => {
        button.addEventListener('click', function (e) {
          
          if (showAllMode) return;
          
          e.preventDefault();          
    
          const currentQuestion = button.closest('.question');
          if (!currentQuestion) return;
    
          if (!validateQuestion(currentQuestion)) return;
    
          const fields = currentQuestion.querySelectorAll('input, textarea, select');
          fields.forEach(f => zf_HideErrorMsg(f.name));
    
          let nextQuestion = currentQuestion.nextElementSibling;
          while (nextQuestion && !nextQuestion.classList.contains('question')) {
            nextQuestion = nextQuestion.nextElementSibling;
          }
          if (!nextQuestion) return;
    
          button.setAttribute('aria-expanded', 'true');
          button.parentElement.style.height = '0';
          nextQuestion.style.display = 'block';
          nextQuestion.style.height = '0px';
          nextQuestion.offsetHeight;
          nextQuestion.style.height = nextQuestion.scrollHeight + 'px';
    
          nextQuestion.addEventListener('transitionend', function handler(e) {
            if (e.propertyName !== 'height') return;
            nextQuestion.style.height = 'auto';
            nextQuestion.scrollIntoView({ behavior: 'smooth', block: 'start' });
            nextQuestion.removeEventListener('transitionend', handler);
          });
        });
      });

      const otherRadio = form.querySelector('#Radio3_3');
      const otherField = form.querySelector('[name="SingleLine1"]');
      const roleRadios = form.querySelectorAll('input[name="Radio3"]');

      roleRadios.forEach(radio => {
        radio.addEventListener('change', () => {
          if (otherRadio && otherField && !otherRadio.checked) {
            otherField.value = '';
            zf_HideErrorMsg('SingleLine1');
          }
        });
      });
    
      // form submit
      form.addEventListener('submit', function(e) {
      
        const questions = form.querySelectorAll('.question');
      
        for (const question of questions) {
      
          // In progressive mode, only validate visible
          if (!showAllMode) {
            if (getComputedStyle(question).display === 'none') continue;
          }
      
          if (!validateQuestion(question)) {
            e.preventDefault();
            return;
          }
        }
      
      });
    
    });
    
  };

  formCollapse();
});
